<img [class.disabled]="disabled" src="/assets/Checkbox-isolated-white.svg" />
